import React from 'react';
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import { Select, MenuItem, Paper } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import OfficialDiaryDataTable from './components/official-diary-data-table';
import { IOfficialDiaryDataTableProps } from './components/official-diary-data-table';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import DefaultSelectClient from '../../../components/default-select-client';
import { useOfficialDiarySearchController } from './context/official-diary-search-controller';
import { useOfficialDiarySearchState } from './context/official-diary-search-context';
import PageHeader from '../../../components/page-header';

export function OfficialDiarySearchComponent() {
    const {
        handleOnChange,
        handleStartDateChange,
        handleEndDateChange,
        navigateToCreate
    } = useOfficialDiarySearchController();

    const { datesParameters, parameters } = useOfficialDiarySearchState();

    const dataTableProperties: IOfficialDiaryDataTableProps = {
        parameters: parameters
    };

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Diário Oficial"
                    subtitle="Consulte e gerencie as edições do Diário Oficial"
                    breadcrumbs={[
                        { label: 'SDP', href: '/sdp' },
                        { label: 'Diário Oficial' }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Grid container spacing={1.5}>
                            <Grid item lg={2} sm={2} xl={2}>
                                <InputLabel>Nº Edição</InputLabel>
                                <OutlinedInput
                                    name="input-number"
                                    fullWidth
                                    type={"number"}
                                    inputProps={{ min: 0 }}
                                    value={parameters.number}
                                    onChange={handleOnChange}
                                />
                            </Grid>
                            <Grid item lg={2} sm={2} xl={2}>
                                <InputLabel>Nº Ano</InputLabel>
                                <OutlinedInput
                                    name="input-year"
                                    fullWidth
                                    type={"number"}
                                    inputProps={{ min: 0 }}
                                    value={parameters.year}
                                    onChange={handleOnChange}
                                />
                            </Grid>
                            <Grid item lg={2} sm={2} xl={2}>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    fullWidth
                                    name="select-closed"
                                    value={parameters.isClosed}
                                    onChange={handleOnChange}
                                >
                                    <MenuItem value={undefined}>
                                        <em>Selecionar</em>
                                    </MenuItem>
                                    <MenuItem value={"true"} key={1}>FECHADA</MenuItem>
                                    <MenuItem value={"false"} key={2}>ABERTA</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item lg={3} sm={3} xl={3}>
                                <InputLabel>Data Edição Inicial</InputLabel>
                                <DesktopDatePicker
                                    inputFormat="DD/MM/YYYY"
                                    maxDate={moment()}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                    value={datesParameters.starDatePicker.toDate()}
                                    onChange={handleStartDateChange}
                                />
                            </Grid>
                            <Grid item lg={3} sm={3} xl={3}>
                                <InputLabel>Data Edição Final</InputLabel>
                                <DesktopDatePicker
                                    inputFormat="DD/MM/YYYY"
                                    maxDate={moment()}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                    value={datesParameters.endDatePicker.toDate()}
                                    onChange={handleEndDateChange}
                                />
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12}>
                                <DefaultSelectClient
                                    required={false}
                                    clientId={parameters.clientId}
                                    handleOnChange={handleOnChange}
                                />
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                </Paper>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        minHeight: "500px",
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <OfficialDiaryDataTable props={dataTableProperties} />
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={navigateToCreate}
                        icon={<SpeedDialIcon />}
                    />
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
